import {
  TokenAnalytics,
  WebsocketResponse,
  WebsocketResponseTypes,
} from '../models/websockets.types';

const websocketResponseParser = (response: string): WebsocketResponse => {
  let parsedResponse;
  let responseType: WebsocketResponseTypes;
  try {
    parsedResponse = JSON.parse(response);
  } catch (error) {
    console.error('Error parsing websocket response:', error);
    throw new Error('Invalid JSON format');
  }
  try {
    responseType = parsedResponse.type as WebsocketResponseTypes;
  } catch (error) {
    console.error('Error parsing websocket response type:', error);
    throw new Error('Invalid response type');
  }
  const finalResponse = {
    type: responseType,
    data: parsedResponse.data,
  };
  switch (responseType) {
    case WebsocketResponseTypes.LLM_ANSWER:
    case WebsocketResponseTypes.SERVER_ERROR:
    case WebsocketResponseTypes.CONVERSATION_TITLE:
    case WebsocketResponseTypes.END_OF_STREAM:
      finalResponse.data = parsedResponse.data as string;
      break;
    case WebsocketResponseTypes.TOKEN_ANALYTICS:
      finalResponse.data = parsedResponse.data as TokenAnalytics;
      break;
    default:
      throw new Error('Unhandled response type');
  }
  return finalResponse as WebsocketResponse;
};

export const WebsocketServices = {
  websocketResponseParser,
};
